/**
 * Issue #404 加固 — 图形验证码 SVG 的「图片上下文」安全渲染助手。
 *
 * V1.0.6 审计条目 9：delete-captcha 组件曾用 dangerouslySetInnerHTML 直接注入后端 SVG，
 * 是仓库内 raw HTML/SVG 注入点。改为把 SVG 编码进 data:image/svg+xml URI，由 <img> 加载：
 * 浏览器按图片解析该 SVG，脚本（<script> / onload / 外链）一律不执行、不发起请求，从根上
 * 消除注入面（纵深防御，即便未来后端渲染逻辑被污染也不会在管理端执行脚本）。
 *
 * 编码选 encodeURIComponent 而非 base64：
 *   - 验证码 SVG 的 aria-label 含中文，btoa 会在非 Latin1 字符上抛 InvalidCharacterError；
 *   - 颜色值形如 fill="#1f2937"，`#` 不转义会被 URL 当作 fragment 起点截断 SVG。
 * encodeURIComponent 同时处理 UTF-8 与 `#`（→ %23）、`<`（→ %3C）、`>`（→ %3E）等。
 * 纯函数，零依赖，便于单测。
 */
export function svgToDataUri(svg: string): string {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
